import { render, staticRenderFns } from "./OnboardingFooter.vue?vue&type=template&id=673cda61"
import script from "./OnboardingFooter.vue?vue&type=script&lang=js"
export * from "./OnboardingFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports